import { ADMIN_PERMISSION_NAME } from '../constant/api';
import { MODERATOR_PASS_KIND } from '../constant/app';
import { AutorizationResponseType } from '../types/app.types';
import { IPersonPass } from '../types/passes.types';

export const isAdmin = (user: AutorizationResponseType) =>
	user?.permissions?.some((permission) => permission === ADMIN_PERMISSION_NAME);

export const isModerator = (passes: IPersonPass[]) =>
	passes?.some((pass) => pass.pass_type && pass.pass_type.kind === MODERATOR_PASS_KIND);
